import { gql } from 'apollo-angular';

export const SaveAccountSetupDocument = gql/* GraphQL*/ `
  mutation saveAccountSetup($worksFor: WorksForEnum!, $parameters: [SaveAccountSetupInputGraphql!]!) {
    saveAccountSetup(worksFor: $worksFor, parameters: $parameters)
  }
`;
